module.exports = __webpack_public_path__ + "img/kid-icarus.39c716e4.png";